import DetailedPage from "./index";

function SharingMode() {
    return (
        <DetailedPage  sharing={true} content={true} />
    );
}
export default SharingMode;